export default __webpack_public_path__ + "static/media/swipe_background_imagew.0e555cd3.png";